<template>
  <div>
    <div style="width: 60%" ref="invoiceRef">
      <vs-card>
        <div id="printMeOdeme">
          <table style="width: 100%; margin-bottom: 50px" class="border-collapse">
            <tr>
              <td>
                <img
                  src="https://int.kamyonyedekparca.com/uploads/logo.png"
                  style="max-height: 75px"
                  alt="login"
                  class="mx-auto"
                />
              </td>
            </tr>
          </table>
          <div style="margin-bottom: 50px">
            <p style="text-align: start; font-weight: 600; margin-bottom: 50px">
              Sayın {{ ACTNAME }}
            </p>

            <p>
              Açık faturalarınızın ortalama vadeleri ve fatura detayları aşağıda
              listelenmiştir. Ödeme günü geçmiş olanlar varsa kırmızı renkte
              işaretlenmiştir. Vade tarihlerine göre uygun evrak gönderilmesini rica
              ederiz.
            </p>
            <p style="margin-bottom: 50px">Bu mail otomatik gönderilmiştir.</p>
            <p style="margin-bottom: 50px; font-weight: 600">
              TEMSİLCİ: ÖMER GİRGİN (muhasebe@canergroup.com.tr)
            </p>
          </div>

          <table style="width: 100% !important; text-align: center" id="printMeOdeme">
            <tr>
              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>FATURA NO</p>
              </th>
              <th
                sort-key="stokkodu"
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>TARİH</p>
              </th>

              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>VADE TARİHİ</p>
              </th>
              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>FARK GÜN</p>
              </th>

              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>FATURA TUTARI</p>
              </th>
              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>ÖDEME TUTARI</p>
              </th>
              <th
                style="
                  text-align: center;
                  border: 1px solid grey;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>AÇIK TUTAR</p>
              </th>
            </tr>

            <tr
              :key="indextr"
              v-for="(tr, indextr) in itemListele"
              :style="getIsDate(tr.DUEDATE) ? 'background-color: #f29899;' : ''"
            >
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ tr.FATURANO }}</p>
              </td>
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ parseDate(tr.TRANSDATE) }}</p>
              </td>
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ parseDate(tr.DUEDATE) }}</p>
              </td>
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ tr.farkgun }}</p>
              </td>

              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ currencyFormatter(tr.FaturaTutar, "₺") }}</p>
              </td>
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>
                  {{
                    currencyFormatter(
                      parseFloat(tr.FaturaTutar) - parseFloat(tr.TUTAR),
                      "₺"
                    )
                  }}
                </p>
              </td>
              <td
                style="padding: 3px; font-size: 15px !important; border: 1px solid grey"
              >
                <p>{{ currencyFormatter(tr.TUTAR, "₺") }}</p>
              </td>
            </tr>
            <tr style="background-color: lightgrey">
              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              ></td>
              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                ORTALAMA VADE
              </td>

              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                {{ parseDate(ortalamaVade) }}
              </td>
              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              ></td>

              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              ></td>
              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                TOPLAM AÇIK TUTAR
              </td>

              <td
                style="
                  font-weight: bold;
                  padding: 3px;
                  font-size: 15px !important;
                  border: 1px solid grey; ;
                "
              >
                <p>{{ currencyFormatter(FaturaToplamTutar, "₺") }}</p>
              </td>
            </tr>
          </table>

          <div style="margin-top: 50px; margin-bottom: 50px">
            <p style="font-weight: 600">
              Caner Group <span style="font-weight: 400">{{ TARIH }}</span>
            </p>
            <p>Aşağıdaki şirket tarafından gönderildi</p>
            <p style="font-weight: 600">DENİZLİ CANER OTOMOTİV SAN.TİC.A.Ş.,</p>
            Sevindik Mah. 2290 Sok. No: 96/A Merkezefendi / DENİZLİ, TÜRKİYE.
          </div>
          <p style="margin-bottom: 50px">
            Güncel Carinizde Mutabıksanız Lütfen Onayla Butonuna Değilseniz Reddet
            Butonuna Tıklayınız. (Reddetme sebebinizi de açılan kutucuğa yazmanızı rica
            ederiz.).
          </p>
          <b-row v-if="DURUM">
            <b-col style="margin: 8px">
              <vs-button
                v-if="DURUM != 'Onaylandı' && DURUM != 'Red'"
                style="border-radius: 5px; width: 100%"
                type="gradient"
                id="button-with-loading-yeni"
                class="vs-con-loading__container"
                size=""
                color="success"
                @click="updateAcikFatura('Onaylandı')"
                >Onayla</vs-button
              >
            </b-col>
            <b-col style="margin: 8px">
              <vs-button
                v-if="DURUM != 'Onaylandı' && DURUM != 'Red'"
                style="border-radius: 5px; width: 100%"
                type="gradient"
                id="button-with-loading-yeni"
                class="vs-con-loading__container"
                size=""
                color="danger"
                @click="
                  red = true;
                  updateAcikFatura('Red');
                "
                >Reddet</vs-button
              >
            </b-col>
          </b-row>
          <b-row style="margin-top: 8px">
            <b-col style="margin: 8px">
              <vs-button
                style="border-radius: 5px; width: 100%"
                type="gradient"
                id="button-with-loading-yeni"
                class="vs-con-loading__container"
                size=""
                @click="yazdir()"
                >Yazdır</vs-button
              >
            </b-col>
            <b-col style="margin: 8px">
              <vs-textarea
                v-if="red"
                v-model="description"
                placeholder="Red nedenini yazıp, tekrar Reddet butonuna basınız."
              >
              </vs-textarea>
            </b-col>
          </b-row>
          <hr />
          <p>
            YASAL UYARI Bu e-posta, içeriği ve ekleri gizli bilgi ve kişisel veri
            içermektedir. Eğer bu e-postanın muhatabı değilseniz bu e-posta ve eklerinin
            kopyalarını herhangi bir şekilde gönderemez, dağıtamaz veya yedekleyemezsiniz.
            Bu durumda hukuki sorumluluğunuzun doğmaması için lütfen bu e-postayı
            gönderene bildiriniz ve e-posta ve ekindeki belgeleri bütün sistemlerinizden
            siliniz. Bu e-postanın muhatabı ilgili bilgilerin kendisi adına başka bir
            gerçek veya tüzel kişi tarafından kullanılması halinde başta Kişisel Verilerin
            Korunması Kanunu olmak üzere ilgili diğer yasa ve mevzuat tahtında bu
            kişilerle birlikte müşterek sorumlu olduğunu, bu sebeple söz konusu bilgi ve
            verilerin korunmasına yönelik her türlü idari ve teknik tedbiri almakla
            yükümlü olduğunu kabul eder. 6698 sayılı Kişisel Verilerin Korunması Kanunu
            kapsamında kişisel verileriniz veri sorumlusu sıfatıyla şirketimiz CANER GROUP
            tarafından işlenebilmektedir. Veri sorumlusunun “Aydınlatma Yükümlülüğü”nü
            yerine getirebilmesi amacıyla hazırlanan Kişisel Verilerin İşlenmesi
            Politikası ve Aydınlatma Metinlerine https://canergroup.com.tr adresinden
            ulaşabilirsiniz. İşbu mailin tarafınıza ulaşması ile veri sorumlusu aydınlatma
            yükümlülüğünü yerine getirmiş sayılacaktır. DISCLAIMER This message contains
            confidential information and personal/sensitive personal data and/or
            information. If you are not the named addressee, you should not disseminate,
            distribute or copy this email and its attachment. If you have received this
            e-mail inadvertently, in order to avoid legal liability please notify the
            sender immediately by e-mail and delete it together with its attachments from
            all your systems. The recipient and any third party who use the
            data/information on the recipient’s behalf shall be jointly liable for such
            use in accordance with the law on protection of personal data and other
            relevant laws and regulations. Therefore the recipient acknowledge and agree
            that they shall take all necessary administrative and technical measures for
            the protection of personal data/information. If you have received this message
            despite the fact that you are not the recipient, you shall be responsible for
            keeping this message confidential. In accordance with the Law on Protection of
            Personal Data No. 6698, your personal data can be processed by CANER GROUP as
            the data controller. Please find the "Personal Data Protection Policy" and
            "Information Texts" at our website https://canergroup.com.tr prepared for the
            purpose of fulfilling the obligation to inform the data subjects. Upon receipt
            of this e-mail, the data controller will be deemed to have fulfilled his
            obligation to inform.
          </p>
        </div>
      </vs-card>
    </div>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import userJson from "../../../public/user.json";
import moment from "moment";
import Store from "../../store/store";
import state from "../../store/state";
import { Icon } from "@iconify/vue2";
import { BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import TeklifOnayMailGonder from "../components/crm-components/satis-components/TeklifOnayMailGonder.vue";
export default {
  metaInfo() {
    return {
      title: "Caner Group",
      meta: [
        {
          name: "Bu ileti Caner Group tarafından gönderilen, teklif onayı içindir. ",
          content: "İşlemi onaylıyorum kısmına tıklayıp, onayla butonuna basınız.",
        },
      ],
    };
  },
  props: ["gelenDeger"],
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      red: false,
      description: "",
      MATRAH: 0.0,
      ortalamaVadeGun: 0,

      CURRCODE: "",
      onayCheck: false,
      itemParam: [],
      promtBaslik: "",
      activePrompt: false,
      toplamTutar: 0.0,
      teklifOnayListDetay: [],
      itemListele: [],
      itemListGorev: [],

      ipAdres: "",
      TARIH: "",
      aciklama: "",
      ACTNAME: "",
      DESCRIPTION: "",
      odemeSekli: "",
      teklifiHazirlayan: "",
      adres: "",
      adresTipi: "",

      sevkSekli: "",
      notlar: "",
      onayAdi: "",
      cariAdi1: "",
      onaylayan: "",
      NotesId: "",
      FaturaToplamTutar: 0.0,
      KalanToplamTutar: 0.0,
      kdvToplam: 0.0,
      gnToplam: 0.0,
      onay: "",
      mail: "",
      Panel1Validate: false,
      GridOnayValidate: false,
      DivOnayValidate: false,
      tahsilEdilecek: "",

      imgSrcUrl: "https://servis.kamyonyedekparca.com",
      cariList: [],
      allActListItem: [],
      ortalamaVade: "",
      DURUM: "",
    };
  },
  components: { Icon, TeklifOnayMailGonder },
  methods: {
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMeOdeme");
    },

    getIsDate(itemdate) {
      if (!itemdate) return false;
      const selected = new Date(itemdate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return selected <= today;
    },
    isMobile: function () {
      return isMobile;
    },

    parseDate(date) {
      return moment(String(date)).format("DD.MM.YYYY");
    },
    currencyFormatter(currency, sign) {
      var gelencurr = parseFloat(currency);
      var sansDec = gelencurr.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formatted} ` + sign;
    },

    degerleriHesapla(farkGune, tutar) {
      var vm = this;
      var topFarkGun = 0.0;
      topFarkGun = parseFloat(farkGune) * parseFloat(tutar);
      vm.MATRAH += parseFloat(topFarkGun);

      vm.ortVdeToplamTutar += parseFloat(tutar);
      vm.ortalamaVadeGun = parseInt(vm.MATRAH / vm.ortVdeToplamTutar);
      function addDays(date, days) {
        var result = new Date(date);
        result.setDate(date.getDate() + days);
        return result;
      }
      var date = new Date();
      vm.tahsilEdilecek = addDays(date, vm.ortalamaVadeGun);
      vm.ortalamaVade = moment(String(vm.tahsilEdilecek)).format("MM.DD.YYYY");
    },

    detayaGit(index) {
      var vm = this;
      if (index == -1) {
      } else {
        vm.FaturaToplamTutar = 0.0;
        vm.KalanToplamTutar = 0.0;
        vm.MATRAH = 0.0;
        vm.ortVdeToplamTutar = 0.0;
        const soap = require("soap");
        const url = userJson.userService;
        var args = {
          ACTID: vm.$route.params.ACTID,
        };
        soap.createClient(url, function (err, client) {
          client.rpAcikFaturalarDetay(args, function (err, result) {
            if (result.rpAcikFaturalarDetayResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.rpAcikFaturalarDetayResult);
              vm.itemListele = vm.veriler;
              vm.ACTNAME = vm.itemListele[0].ACTNAME;

              vm.itemListele.forEach((val, index) => {
                vm.FaturaToplamTutar += val.TUTAR;
                vm.KalanToplamTutar += val.TUTAR;
                vm.degerleriHesapla(val.farkgun, val.TUTAR);
              });
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    },
    listAcikFatura(durum) {
      var vm = this;
      const soap = require("soap");
      const url = userJson.userService;
      var args = {
        GONDKEY: vm.$route.params.GONDKEY,
        DURUM: durum,
        ACIKLAMA: "",
        ACTID: vm.$route.params.ACTID,
        isDue: "List",
        filter: vm.$route.params.GONDKEY,
      };
      soap.createClient(url, function (err, client) {
        client.islemAcikFaturalar(args, function (err, result) {
          if (result.islemAcikFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.islemAcikFaturalarResult);
            console.log(vm.veriler.jsonData);
            let controlList = vm.veriler.jsonData;
            vm.DURUM = controlList[0].DURUM;
            vm.description = controlList[0].REDSEBEP;
            console.log(vm.DURUM);
            if (vm.DURUM == "Gönderildi") vm.updateAcikFatura("Görüldü");
          } catch (error) {
            console.log(error);
          }
        });
      });
    },
    updateAcikFatura(durum) {
      var vm = this;
      const soap = require("soap");
      const url = userJson.userService;
      if (durum == "Red" && vm.description == "") {
        const vs = this.$vs;
        vs.notify({
          title: "Ödeme Hatırlatması",
          text: "Açıklama alanını doldurunuz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        var args = {
          GONDKEY: vm.$route.params.GONDKEY,
          DURUM: durum,
          ACIKLAMA: vm.description,
          ACTID: vm.$route.params.ACTID,
          isDue: "Update",
        };
        soap.createClient(url, function (err, client) {
          client.islemAcikFaturalar(args, function (err, result) {
            if (result.islemAcikFaturalarResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.islemAcikFaturalarResult);
              vm.description = "";
              vm.listAcikFatura();
              if (durum != "Görüldü") {
                const vs = vm.$vs;
                vs.notify({
                  title: "Ödeme Hatırlatması",
                  text: "İşleminiz Kaydedildi.",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              }
            } catch (error) {
              console.log(error);
            }
          });
        });
      }
    },
  },
  created() {
    this.TARIH = moment(String(new Date())).format("DD.MM.YYYY HH:mm:ss");

    this.detayaGit();
    this.listAcikFatura("");
  },
};
</script>
